var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68.738976mm",
    height: "68.354317mm",
    viewBox: "0 0 68.738976 68.354317",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-10.439759,-8.2218044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10086",
    transform: "translate(3.0742265)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59194b",
      fillOpacity: 1,
      strokeWidth: 0.499999,
      paintOrder: "stroke fill markers"
    },
    d: "m 35.503414,8.221804 -22.389621,13.59936 -5.7482595,23.19924 10.8290525,24.747968 31.473509,6.80775 24.447236,-16.868988 1.98918,-27.32198 -14.72361,-20.66155 z",
    id: "path236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path442-7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.499999,
      paintOrder: "stroke fill markers"
    },
    d: "m 30.00453,17.15893 -0.01402,1.787903 0.46762,0.342971 -0.47262,0.292542 -0.0709,9.042034 -2.69389,0.89917 -2.66754,4.92476 -0.12144,21.97437 5.51697,3.10472 h 2.77348 l 0.10594,-19.15439 2.66753,-4.92476 2.69338,-0.89865 0.0382,-4.85965 -3.36879,-1.25781 0.107455,-8.873463 -0.464296,-0.167899 0.470796,-0.370663 0.01935,-1.598155 z m 20.00032,0.4625 -0.01261,1.608064 0.255835,0.360249 -0.261495,0.361691 -0.07163,9.135446 -2.69338,0.89865 -0.24236,0.44804 -0.0398,3.26595 4.28397,1.59939 1.2051,4.1429 0.83406,20.54758 h 2.27686 l 5.7056,-3.26905 -0.89659,-22.08393 -1.2051,-4.1429 -4.28449,-1.59938 -0.108019,-9.095606 -0.29756,-0.30903 0.28866,-0.444383 -0.02194,-1.847179 z m -9.998006,5.419249 -0.0162,2.04181 0.446813,0.321459 -0.439194,0.753595 -0.02529,9.138267 -2.69338,0.89865 -2.66805,4.92476 -0.12092,21.97489 5.51646,3.10472 h 5.59035 l 5.7056,-3.26905 -0.89659,-22.08444 -1.20509,-4.1429 -4.2845,-1.59939 0.162261,-8.18687 -0.562358,-0.295454 0.444937,-0.476445 0.08901,-2.050891 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaOne);
export default __webpack_public_path__ + "static/media/Area_one.c2b3d4ccb9a03a855f8989c9d1f765c4.svg";
export { ForwardRef as ReactComponent };